export class SessionFilterStorage {
  /**
   * Session storage that is configured to save filter object, sync version.
   */

  constructor({
    featureName = '',
    sessionStore,
    storageKey,
  } = {}) {
    if (!sessionStore) {
      throw new Error('No session store is provided');
    }

    if (storageKey) {
      this.storageKey = storageKey;
    } else {
      this.storageKey = this.getStorageKey(featureName);
    }

    this.featureName = featureName;
    this.storage = sessionStore;
  }

  getStorageKey() {
    throw new Error('Not implemented');
  }

  save(filter) {
    this.storage.set(this.storageKey, filter);
  }

  get() {
    const data = this.storage.get(this.storageKey);
    return data ? { filter: data } : null;
  }
}
